import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import {Table, Data } from 'components/layout/Table'
import { recipients as recipientsLayout } from 'constants/layout'
import { get } from 'lodash'
import {FormattedDate} from "../../../intl";
import {Link} from "react-router-dom";
import config from "../../../../config";

@injectIntl
export default class RecipientsTable extends Component {
  static propTypes = {
    recipients: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {}

  handleViewMessage = message => {
    this.setState(
        {
          message
        },
        () => {
          this.props.modal(`modal-view-message-${this.key}`)
        }
    )
  }

    handleViewRecipients = recipients => {
        this.setState(
            {
                recipients
            },
            () => {
                this.props.modal(`modal-view-recipients-${this.key}`)
            }
        )
    }

    getMessageTypeList = messageDetail => {

      let msgTypes = get(messageDetail, 'notificationDeliveryTypes')

        msgTypes = msgTypes && msgTypes.map(t => { return t.replace("PUSH", "NOTIFICATION") });

       if(msgTypes && msgTypes.length > 0) {
           return msgTypes.join(", ");
       } else {
           return '---'
       }

    }

  render() {
    const {
      recipients,
    } = this.props

    return (
      <div>
        <Table
          ths={recipientsLayout.tableHeaders()}
        >
          <Data>
            {recipients.map(({ id, firstName, lastName, email, messageDetailDto }) => (

              <tr key={id}>
                <td><Link to={{ pathname: `${config.publicPath}/participants/${id}/detail` }}>{id}</Link></td>
                <td>{firstName}</td>
                <td>{lastName}</td>
                <td>{email}</td>
                <td>{this.getMessageTypeList(messageDetailDto)}</td>
                <td>{get(messageDetailDto, 'pushReadDate') ? (<FormattedDate value={get(messageDetailDto, 'pushReadDate')} />) : '---'}</td>
              </tr>
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}
